import React from 'react';
import ImageModule from '../../Module/Image';
import TextModule from '../../Module/Text';
import ModuleEdit from '../../Module/Edit';
import EmptyModel from '../../Empty';
import { useMessageManagerProvider } from '../../../../../../../context/messageManager';
import TabsNavigation from '../Navigation';

export function CompanyInfo() {
  return (
    <div className="grid text-[12px] leading-[16px]">
      <div>
        <img src="/infoTrac/images/step-2-logo.png" alt="image1" className="w-[220px] mb-[5px]" />
        <div className="ml-[10px] opacity-70">
          <div>P.O Box 123 | San Francisco, CA 95423</div>
          <div>www.guidancefinancial.com</div>
          <div>+1.800.564.5659</div>
        </div>
      </div>
      <div className="self-end [&_div]:opacity-70">
        <div>Carson Client</div>
        <div>Jack Henry Symitar (EXBK)</div>
        <div>141 Jefferson Drive</div>
        <div>Menlo Park, CA 94025-1234</div>
        <img src="/infoTrac/images/step-2-image-5.png" alt="image2" className="self-center w-[200px] mt-[10px]" />
      </div>
    </div>
  );
}

function Statement() {
  const { selectedModule } = useMessageManagerProvider();

  return (
    <div className="grid grid-cols-[45%,1fr] gap-x-[20px]">
      <div>
        <TabsNavigation />
        <div className="grid bg-white gap-y-[10px] content-start border py-[20px] px-[30px]">
          <div className="grid gap-2 grid-cols-2 justify-between">
            <CompanyInfo />
            <ImageModule className="w-[300px] justify-self-end mt-[50px]" />
          </div>
          <TextModule />
          <img src="/infoTrac/images/step-2-tables.png" alt="image3" className="self-end" />
        </div>
      </div>
      <div className="bg-white grid border">
        {selectedModule?.item !== undefined ? <ModuleEdit tab={0} /> : <EmptyModel />}
      </div>
    </div>
  );
}

export default Statement;
